module.exports = __webpack_public_path__ + "static/SuisseIntl-Light-e53b63d8bd99da09b4f14536f3d509d5.woff";